"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _addonSummary = _interopRequireDefault(require("./addonSummary.proptypes"));
var _constant = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var AddonSummaryContainer = _styledComponents.default.div.withConfig({
  displayName: "AddonSummary__AddonSummaryContainer",
  componentId: "sc-1wvgc5k-0"
})([""]);
var SummaryContainer = _styledComponents.default.div.withConfig({
  displayName: "AddonSummary__SummaryContainer",
  componentId: "sc-1wvgc5k-1"
})([""]);
var HeaderSection = _styledComponents.default.div.withConfig({
  displayName: "AddonSummary__HeaderSection",
  componentId: "sc-1wvgc5k-2"
})(["display:flex;padding:", ";background-color:", ";border-top:", ";border-bottom:", ";"], function (_ref) {
  var theme = _ref.theme,
    isMobile = _ref.isMobile;
  return !isMobile ? "".concat(theme.space.tiny, " ").concat(theme.space.standard) : "".concat(theme.space.tiny, " ").concat(theme.space.small);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.backgroundColor.greyLighter;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "1px solid ".concat(theme.colors.greyLight);
}, function (_ref4) {
  var theme = _ref4.theme;
  return "1px solid ".concat(theme.colors.greyLight);
});
var HeaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "AddonSummary__HeaderWrapper",
  componentId: "sc-1wvgc5k-3"
})([""]);
var BodySection = _styledComponents.default.div.withConfig({
  displayName: "AddonSummary__BodySection",
  componentId: "sc-1wvgc5k-4"
})(["display:flex;flex-direction:", ";padding:", ";"], function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? 'column' : 'row';
}, function (_ref6) {
  var theme = _ref6.theme,
    isMobile = _ref6.isMobile;
  return !isMobile ? "".concat(theme.space.small, " ").concat(theme.space.standard) : "".concat(theme.space.small);
});
var Title = _styledComponents.default.div.withConfig({
  displayName: "AddonSummary__Title",
  componentId: "sc-1wvgc5k-5"
})(["display:flex;flex-direction:row;"]);
var PaxName = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "AddonSummary__PaxName",
  componentId: "sc-1wvgc5k-6"
})(["font-size:", ";line-height:", ";color:", ";flex:1;"], function (_ref7) {
  var theme = _ref7.theme,
    isMobile = _ref7.isMobile;
  return !isMobile ? theme.fontSize.normal : theme.fontSize.small;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.lineHeight.XLarge;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.greyDark;
});
var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "AddonSummary__IconContainer",
  componentId: "sc-1wvgc5k-7"
})(["display:flex;align-items:center;"]);
var JourneyWiseWrapper = _styledComponents.default.div.withConfig({
  displayName: "AddonSummary__JourneyWiseWrapper",
  componentId: "sc-1wvgc5k-8"
})(["display:flex;flex-direction:column;flex:1;", ""], function (_ref10) {
  var indexVal = _ref10.indexVal,
    theme = _ref10.theme,
    isMobile = _ref10.isMobile;
  return indexVal > 0 && isMobile && (0, _styledComponents.css)(["margin-top:", ";"], theme.space.extraStandard);
});
var Status = _styledComponents.default.div.withConfig({
  displayName: "AddonSummary__Status",
  componentId: "sc-1wvgc5k-9"
})(["display:flex;flex-direction:row;margin-right:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.tiny;
});
var SelectedAncillary = _styledComponents.default.div.withConfig({
  displayName: "AddonSummary__SelectedAncillary",
  componentId: "sc-1wvgc5k-10"
})(["margin-left:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.tiny;
});
var AddonSummary = function AddonSummary(props) {
  var theme = props.theme,
    accessible = props.accessible,
    summaryData = props.summaryData,
    stationDetails = props.stationDetails,
    isMobile = props.isMobile,
    translation = props.translation;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';
  var clickHandler = function clickHandler(currIndex) {
    return setActiveIndex(function (prevValue) {
      return currIndex === prevValue ? -1 : currIndex;
    });
  };
  var getHeaderSection = function getHeaderSection(paxName, selectedAncillaries, currIndex) {
    var isExpanded = currIndex === activeIndex;
    var ancillaryCategories = [];
    selectedAncillaries.forEach(function (_ref13) {
      var data = _ref13.data;
      return data.forEach(function (_ref14) {
        var category = _ref14.category;
        return ancillaryCategories.push(category);
      });
    });
    ancillaryCategories = (0, _toConsumableArray2.default)(new Set(ancillaryCategories));
    return /*#__PURE__*/_react.default.createElement(HeaderSection, {
      onClick: function onClick() {
        return clickHandler(currIndex);
      },
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(PaxName, {
      accessible: accessible,
      bold: true,
      isMobile: isMobile,
      tag: _constant.TAG.div
    }, paxName), !isExpanded && /*#__PURE__*/_react.default.createElement(Status, null, ancillaryCategories.map(function (category) {
      return /*#__PURE__*/_react.default.createElement(SelectedAncillary, {
        key: category
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        color: _constant.ICON_TYPE.normal.color,
        fontsize: _constant.ICON_TYPE.normal.size,
        icon: _constant.ANCILLARY_TYPE_ICONS[category]
      }));
    })), /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      theme: theme,
      accessible: accessible,
      color: _constant.ICON_TYPE.normal.color,
      fontsize: _constant.ICON_TYPE.normal.size,
      icon: isExpanded ? _constant.ICONS.EXPAND_LESS_ICON : _constant.ICONS.EXPAND_MORE_ICON
    })));
  };
  var getAncillaryItem = function getAncillaryItem(selAncillary) {
    var title = selAncillary.title,
      icon = selAncillary.icon;
    return /*#__PURE__*/_react.default.createElement(Title, {
      key: title
    }, /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      theme: theme,
      accessible: accessible,
      color: _constant.ICON_TYPE.neutral.color,
      fontsize: _constant.ICON_TYPE.neutral.size,
      icon: icon
    })), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      theme: theme,
      type: _constant.TEXT_TYPE.normal.type,
      bold: true,
      color: _constant.TEXT_TYPE.normal.color,
      marginLeft: _constant.MARGIN.micro,
      tag: _constant.TAG.div
    }, title));
  };
  var getJourneyWiseSummary = function getJourneyWiseSummary(designator, data, indexVal) {
    var departureStation = designator.departureStation,
      arrivalStation = designator.arrivalStation;
    var stn = stationDetails;
    var journey = "".concat(stn && stn[departureStation] ? stn[departureStation].StationName : departureStation, " ").concat(language.to, "\n    ").concat(stn && stn[arrivalStation] ? stn[arrivalStation].StationName : arrivalStation);
    return /*#__PURE__*/_react.default.createElement(JourneyWiseWrapper, {
      key: journey,
      indexVal: indexVal,
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      accessible: accessible,
      type: _constant.TEXT_TYPE.light.type,
      color: _constant.TEXT_TYPE.light.color
    }, journey), data.map(function (selAncillary) {
      return getAncillaryItem(selAncillary);
    }));
  };
  var getSummaryPerPax = function getSummaryPerPax(summaryPerPax, currIndex) {
    var paxName = summaryPerPax.paxName,
      selectedAncillaries = summaryPerPax.selectedAncillaries,
      paxReferenceId = summaryPerPax.paxReferenceId;
    var isExpanded = currIndex === activeIndex;
    return /*#__PURE__*/_react.default.createElement(SummaryContainer, {
      key: paxReferenceId
    }, /*#__PURE__*/_react.default.createElement(HeaderWrapper, null, getHeaderSection(paxName, selectedAncillaries, currIndex)), isExpanded && /*#__PURE__*/_react.default.createElement(BodySection, {
      isMobile: isMobile
    }, selectedAncillaries.map(function (_ref15, indexVal) {
      var designator = _ref15.designator,
        data = _ref15.data;
      return getJourneyWiseSummary(designator, data, indexVal);
    })));
  };
  var getMain = function getMain() {
    var data = summaryData;
    return /*#__PURE__*/_react.default.createElement(AddonSummaryContainer, {
      tabIndex: tabIndex
    }, data.map(function (summaryPerPax, idx) {
      return getSummaryPerPax(summaryPerPax, idx);
    }));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
AddonSummary.propTypes = _addonSummary.default.PropTypes;
AddonSummary.defaultProps = _addonSummary.default.DefaultProps;
var _default = AddonSummary;
exports.default = _default;